module.exports = __webpack_public_path__ + "img/offers-icon-change.4fafda8f.svg";